import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
} from "firebase/firestore";
import { db } from "../firebaseConfig";

const Search = () => {
  const [searchParams] = useSearchParams();
  const searchText = searchParams.get("q") || "";

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const searchNews = async () => {
      setLoading(true);

      try {
        const newsQuery = query(
          collection(db, "news"),
          orderBy("timestamp", "desc"),
          limit(200)
        );

        const snapshot = await getDocs(newsQuery);

        const keyword = searchText.trim().toLowerCase();

        const matchedNews = snapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter((item) => {
            if (!keyword) return false;

            const title = (item.title || "").toLowerCase();

            const tags = Array.isArray(item.tags)
              ? item.tags.join(" ").toLowerCase()
              : "";

            return (
              title.includes(keyword) ||
              tags.includes(keyword)
            );
          });

        setResults(matchedNews);
      } catch (error) {
        console.error("Search error:", error);
        setResults([]);
      }

      setLoading(false);
    };

    searchNews();
  }, [searchText]);

  return (
    <div
      style={{
        maxWidth: "1100px",
        margin: "0 auto",
        padding: "25px 15px 50px",
      }}
    >
     {/* Heading */}
<div
  style={{
    borderLeft: "5px solid #d2202a",
    paddingLeft: "12px",
    marginBottom: "25px",
    display: "flex",
    alignItems: "center",
    gap: "15px",
  }}
>
  <h2
    style={{
      margin: 0,
      fontSize: "25px",
      color: "#333",
    }}
  >
    অনুসন্ধানের ফলাফল
  </h2>

  <div
    style={{
      color: "#777",
      fontSize: "15px",
    }}
  >
    “{searchText}” — {results.length}টি সংবাদ
  </div>
</div>

      {/* Loading */}
      {loading && (
        <div
          style={{
            textAlign: "center",
            padding: "50px 0",
            color: "#777",
          }}
        >
          খোঁজা হচ্ছে...
        </div>
      )}

      {/* No result */}
      {!loading && results.length === 0 && (
        <div
          style={{
            textAlign: "center",
            padding: "60px 20px",
            color: "#777",
            border: "1px solid #eee",
            background: "#fafafa",
          }}
        >
          <div
            style={{
              fontSize: "18px",
              marginBottom: "8px",
              color: "#555",
            }}
          >
            কোনো সংবাদ পাওয়া যায়নি।
          </div>

          <div style={{ fontSize: "14px" }}>
            অন্য কোনো শব্দ দিয়ে আবার অনুসন্ধান করুন।
          </div>
        </div>
      )}

      {/* Results */}
      {!loading && results.length > 0 && (
        <div>
          {results.map((item) => (
            <Link
              key={item.id}
              to={`/${encodeURIComponent(
                item.categorySlug || item.category || ""
              )}/${encodeURIComponent(
                item.subcategorySlug ||
                  item.subcategory ||
                  "all"
              )}/${item.id}`}
              style={{
                display: "flex",
                gap: "15px",
                padding: "15px 0",
                borderBottom: "1px solid #e5e5e5",
                textDecoration: "none",
                color: "#222",
                transition: "all 0.1s ease",
              }}
    onMouseEnter={(e) => {
  e.currentTarget.style.background = "#f5f7ff";

  const title = e.currentTarget.querySelector(".search-result-title");
  if (title) {
    title.style.color = "#4169E1";
  }
}}

onMouseLeave={(e) => {
  e.currentTarget.style.background = "transparent";

  const title = e.currentTarget.querySelector(".search-result-title");
  if (title) {
    title.style.color = "#222";
  }
}}
            >
              {/* Image */}
              {item.image ? (
                <img
                  src={item.image}
                  alt={item.title}
                  style={{
                    width: "180px",
                    height: "90px",
                    objectFit: "cover",
                    borderRadius: "5px",
                    flexShrink: 0,
                  }}
                />
              ) : (
                <div
                  style={{
                    width: "180px",
                    height: "105px",
                    background: "#eee",
                    borderRadius: "5px",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#999",
                  }}
                >
                  ছবি নেই
                </div>
              )}

              {/* Text */}
              <div
                style={{
                  flex: 1,
                  minWidth: 0,
                }}
              >
            <h3
  className="search-result-title"
  style={{
    margin: "0 0 8px",
    fontSize: "21px",
    lineHeight: "1.5",
    fontWeight: "700",
    color: "#222",
    transition: "color 0.2s ease",
  }}
>
  {item.title}
</h3>

                <div
                  style={{
                    fontSize: "14px",
                    color: "#d2202a",
                    marginBottom: "5px",
                  }}
                >
                  {item.category || ""}
                  {item.subcategory
                    ? ` — ${item.subcategory}`
                    : ""}
                </div>

                <div
                  style={{
                    fontSize: "13px",
                    color: "#888",
                  }}
                >
                  👁 {item.views || 0} বার পঠিত
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Search;